<h2 class="title m-0 mb-4">
  {{ 'wl.anz.home_page.quick_access.title' | translate }}
</h2>

<div class="quick-access-links rounded-md px-7 py-4 lg:px-8 lg:py-7">
  <ng-container
    *ngIf="authRenderState === 'loggedIn'; else personalizationAccessLinks">
    <div class="link pb-4 lg:pb-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-redemptions"
        iconTheme="primary"></rd-shared-icon>
      <a class="focus-link cursor-pointer" routerLink="/orders">{{
        'wl.anz.home_page.quick_access.redemptions' | translate
      }}</a>
    </div>

    <div class="link pb-4 pt-4 lg:pb-0 lg:pt-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-points-statement"
        iconTheme="primary"></rd-shared-icon>
      <a class="focus-link cursor-pointer" routerLink="/points_activity">{{
        'wl.anz.home_page.quick_access.points_statement' | translate
      }}</a>
    </div>

    <div *ngIf="!isAnzSSOEnabled" class="link pt-4 lg:pt-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-change-password"
        iconTheme="primary"></rd-shared-icon>
      <a
        class="change-password focus-link cursor-pointer"
        [href]="changePasswordUrl"
        (click)="handleChangePassword($event)"
        >{{ 'wl.anz.home_page.quick_access.change_password' | translate }}</a
      >
    </div>
  </ng-container>

  <ng-template #personalizationAccessLinks>
    <div *ngIf="!isAnzSSOEnabled" class="link pb-4 lg:pb-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-activate-account"
        iconTheme="primary"></rd-shared-icon>
      <a
        class="focus-link cursor-pointer"
        (click)="handleNonLoggedInAction('activate_account')"
        >{{ 'wl.anz.home_page.quick_access.activate_account' | translate }}</a
      >
    </div>

    <div class="link pb-4 pt-4 lg:pb-0 lg:pt-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-faq"
        iconTheme="primary"></rd-shared-icon>
      <a class="focus-link cursor-pointer" routerLink="/faq">{{
        'wl.anz.home_page.quick_access.faq' | translate
      }}</a>
    </div>

    <div *ngIf="!isAnzSSOEnabled" class="link pt-4 lg:pt-0">
      <rd-shared-icon
        class="mr-4"
        iconSymbol="icon-login"
        iconTheme="primary"></rd-shared-icon>
      <a
        class="login focus-link cursor-pointer"
        (click)="handleNonLoggedInAction('login')"
        >{{ 'wl.anz.home_page.quick_access.login' | translate }}</a
      >
    </div>
  </ng-template>
</div>
